<!-- Two compact lines, so the row keeps the table's usual height -->
<div class="flex min-w-0 max-w-[22rem] flex-col">
  <span
    data-request-title
    class="truncate text-xs font-medium leading-4 text-neutral-900"
    [title]="title()">
    {{ title() }}
  </span>
  <span
    data-request-meta
    class="truncate mt-x-sm text-[0.65rem] leading-3 text-neutral-500 rtl:text-xs2 rtl:leading-4">
    <span>{{ requestId() }}</span>
    @if (showTypeUnderTitle()) {
      <span class="text-neutral-300" aria-hidden="true">{{ ' · ' }}</span>
      <span [title]="workflowType()">{{ workflowType() }}</span>
    }
  </span>
</div>
